import { APIType } from '~/backend/types';
import { useDosePrediction } from '~/hooks/workflows/backend/tasks/useDosePrediction';
import { useBackendModels } from '~/hooks/workflows/backend/useBackend';
import DosePrediction from './DosePrediction';

export default function DosePredictionBackendWorkflow() {
    const { startProcessing, isSubmitting } = useDosePrediction();
    const {
        data: availableModels = [],
        isLoading,
        error,
    } = useBackendModels(APIType.DOSE);

    return (
        <DosePrediction
            onSubmit={startProcessing}
            availableModels={availableModels}
            error={error}
            isLoadingModels={isLoading}
            isSubmitting={isSubmitting}
            showPseudonymization={true}
        />
    );
}
